import diffModalTemplate
    from "../../../components/components/contact-duplicate-notice/views/diff-contacts-modal.tpl.html";

export default class ContactsDuplicatesExtendedListViewCtrl {
    get row() {
        return this._row;
    }

    set row(value) {
        this._row = value;
    }

    constructor($injector, $scope) {
        this.injector = $injector;
        this.scope = $scope;
        this.row = null;
        this.api = this.injector.get('$http');
        this.growl = this.injector.get('growl');
        this.filter = this.injector.get('$filter');
        this.alert = this.injector.get('Alert');
        this.state = this.injector.get('$state');
        this.translate = this.injector.get('$translate');
        this.window = this.injector.get('$window');
        this.modal = this.injector.get('$uibModal');

        this.loading = true;
        this.noDuplicatesStates = {};
        this._initWatchers();
    }

    setRow(row) {
        this._row = row;
        this._updateNoDuplicateStates();
        this.init();
    }

    setStore(store) {
        this.store = store;
        this.init();
    }

    init() {
        if (this.row && this.store) {
            this.loadData();
        }
    }

    async loadData() {
        this.contactsStore = this.injector.get('Contacts').reset();
        await this.contactsStore.dispatch('loadState')
        this.contactsStore.commit('setPersistMode', false)
        this.contactsStore.dispatch('clearFilters', false)
        this.contactsStore.commit('setKeyword', '')

        await this.contactsStore.dispatch('getDefinitions')
        const visibleFields = [
            'customer_number',
            'rsvps_all'
        ];

        const columns = this.contactsStore.getters.columns;
        _.each(columns, (col) => {
            if (visibleFields.indexOf(col.key) !== -1) {
                col.visible = true
            }
        });
        this.contactsStore.commit('setColumns', columns);
        this._doMainStoreUpdate();
    }

    confirmNDeleteRsvp(row) {
        const translatedValue = (path, params) => {
            return this.translate.instant(`store.contacts.controllers.ask-to-archive-contact.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {contact_name: row.full_name || row.first_name + ' ' + row.last_name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            }).then(() => {
            this.api.delete(`contacts/${row.id}`)
                .then(() => {
                    this.growl.success(`${row.full_name} archived`, {title: 'Success'});
                    this._doMainStoreUpdate();
                }, () => {
                    this.growl.error(`Error while archiving contact`, {title: 'Success'});
                    this._doMainStoreUpdate();
                });
        }, () => {

        });
    }

    editContact(row) {
        this.state.go('app.contacts.edit', {
            id: row.id
        })
    }

    showContact(row) {
        var url = this.state.href('app.contacts.details.overview', {
            id: row.id
        });
        this.window.open(url, '_blank');
    }

    checkIfIdIsNew(id) {
        let entityInformation = _.first(this.filter('filter')(this.row.duplicate_information.entities, {id: id}));

        if (entityInformation) {
            return entityInformation.is_new;
        }

        return false;
    }

    getUnresolvedCount() {
        return _.filter(this.noDuplicatesStates).length;
    }

    _updateNotADuplicateStateOfId(id, newState) {
        const requestData = {
            identifier: this.row.duplicate_information.identifier,
            primary: id,
            table: this.store.state.slug
        };
        let promise;

        if (!newState) {
            promise = this.api.post(`fp/duplicates/no-duplicate`, requestData);
        } else {
            promise = this.api.delete(`fp/duplicates/no-duplicate`, {
                data: requestData,
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                }
            });
        }

        promise.then(() => {
            this._doMainStoreUpdate();
        }, () => {
            this.growl.error('Error while marking as no duplicate', {title: 'Error'});
            this._doMainStoreUpdate();
        });
    }

    _updateDuplicateStates(newValues, oldValues) {
        _.each(newValues, (state, id) => {
            if (state !== oldValues[id]) {
                this._updateNotADuplicateStateOfId(id, state);
            }
        });
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.noDuplicatesStates;
        }, (newValue, oldValue) => {
            this._updateDuplicateStates(newValue, oldValue);
        }, true);
    }

    _updateNoDuplicateStates() {
        this.noDuplicatesStates = {};

        _.each(this.row.duplicate_information.entities, (row) => {
            this.noDuplicatesStates[row.id] = row.is_new;
        });
    }

    _doMainStoreUpdate() {
        if (this.store) {
            this.store.dispatch('getData').then(() => {
                this._updateRowFromStore();
                this._justReloadData();
                this.scope.$applyAsync();
            });
        }
    }

    _justReloadData() {
        this.contactsStore.commit('unsetFilter', {key: 'id'});
        this.contactsStore.commit('setFilter', {
            key: 'id',
            value: _.map(this.row.duplicate_information.entities, (entity) => {
                return entity.id;
            }).join(' OR ')
        });

        return this.contactsStore.dispatch('getData').then(() => {
            this._calculateDifferentValueColumns();
            this.loading = false;
        })
    }

    _updateRowFromStore() {
        let currentIdentifier = this.row.duplicate_information.identifier,
            newRow = _.first(_.filter(this.store.state.data, (entry) => {
                const rowIdentifier = _.get(entry, 'duplicate_information.identifier');
                return _.isEqual(rowIdentifier, currentIdentifier)
            }));

        if (newRow) {
            this.row = newRow;
        }
    }

    _calculateDifferentValueColumns() {
        this.differentValueColumns = [];
        _.each(this.contactsStore.getters.visibleColumns, (col) => {
            if (this.checkIfColHasDifferentValues(col.key)) {
                this.differentValueColumns.push(col.key);
            }
        });
    }

    checkIfColHasDifferentValues(colKey) {
        let availableValues = [];

        _.each(this.contactsStore.state.data, (row) => {
            availableValues.push(_.get(row, colKey));
        });

        return _.intersection(availableValues).length > 1;
    }

    goToView(newView) {
        this.currentView = newView;
    }

    diffContactsModal(mainContact, contactToDiff) {
        this.modal.open({
            controller: 'DiffContactsModalController',
            controllerAs: 'vm',
            templateUrl: diffModalTemplate,
            size: 'lg',
            resolve: {
                contact1Id: () => {
                    return mainContact.id;
                },
                contact2Id: () => {
                    return contactToDiff.id;
                }
            }
        }).result.then(() => {
            this.showComponent = false;
            this.alert.success('Success', 'Contacts have been merged');

            this.loadData();
        }, (e) => {
            this.alert.success('Error', 'Some error occurred. Please try again.');
            this.loadData();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/store/contacts/controllers/duplicates-extended-list-view.js